import { render } from "./SamplePoints.vue?vue&type=template&id=697258d0"
import script from "./SamplePoints.vue?vue&type=script&lang=js"
export * from "./SamplePoints.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__